<script setup>
import { useRoute, useRouter } from 'vue-router'

definePage({
  meta: {
    layout: 'default',
    action: 'score',
    subject: 'Assessment',
  },
})

const route = useRoute('assessment-score-template-id')
const router = useRouter()
</script>

<template>
  <div>
    <div class="d-flex align-center gap-3 mb-4">
      <VBtn
        icon="ri-arrow-left-line"
        variant="text"
        @click="router.push({ name: 'assessment-templates' })"
      />
      <div>
        <h4 class="text-h4 font-weight-bold">
          Input Nilai
        </h4>
        <p class="text-body-2 text-medium-emphasis mb-0">
          Form penilaian per kriteria (§10.4)
        </p>
      </div>
    </div>

    <ScoreForm :template-id="route.params.templateId" />
  </div>
</template>
